import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Text, spacer16, spacer24, spacer12, } from '@spotify-internal/encore-web';
import { TextLink } from '../../../../../LinkV2';
import { trackCat } from '../../../../constants';
import { TWO_COLUMN_MAX_WIDTH } from '../../Grid';
import { fadeInAnimation } from '../../../../fadeInAnimation';
import { useActiveSubmenuContext } from '../../../../../ActiveSubmenu/ActiveSubmenuProvider';
const sanitizeEyebrow = (eyebrow) => {
    const LENGTH_LIMIT = 25;
    if (eyebrow.length > LENGTH_LIMIT) {
        console.error(`CategoryLinkList: eyebrow exceeded maximum threshold of ${LENGTH_LIMIT}`);
    }
    return eyebrow.substring(0, LENGTH_LIMIT);
};
const sanitizeCategoryLinks = (categoryLinks) => {
    const ITEM_LIMIT = 7;
    const LINK_LENGTH_LIMIT = 20;
    if (categoryLinks.length > ITEM_LIMIT) {
        console.error(`CategoryLinkList: categoryLinks exceeded maximum threshold of ${ITEM_LIMIT}`);
    }
    return categoryLinks
        .filter((_, i) => i < ITEM_LIMIT)
        .map(link => {
        if (link.label.length > LINK_LENGTH_LIMIT) {
            console.error(`CategoryLinkList: link label exceeded maximum threshold of ${LINK_LENGTH_LIMIT}`);
        }
        return Object.assign(Object.assign({}, link), { label: link.label.substring(0, LINK_LENGTH_LIMIT) });
    });
};
const CategoryLinkListSection = styled.section.withConfig({
    shouldForwardProp: prop => !['delay'].includes(prop),
}) `
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    ${({ delay }) => delay && fadeInAnimation(delay)}
  }

  & nav {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top: ${spacer24};

    & li {
      margin-bottom: ${spacer12};
      @media (max-width: 1399px) {
        margin-bottom: ${spacer12};
      }
      @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
        margin-bottom: ${spacer16};
      }
    }

    & li:first-of-type {
      margin-bottom: ${spacer16};
      @media ((min-width: 1400px) or (max-width: ${TWO_COLUMN_MAX_WIDTH})) {
        // override text variant size
        button,
        a {
          span {
            font-size: 32px;
          }
        }
      }
    }
  }
`;
const EyebrowLabel = styled(Text).attrs({
    variant: 'bodyMedium',
    semanticColor: 'textSubdued',
}) ``;
export const CategoryLinkList = ({ eyebrow, categoryLink, subLinks = [], delay, onNavigate = () => { }, }) => {
    const { clearActiveSubmenu } = useActiveSubmenuContext();
    const sanitizedEyebrow = sanitizeEyebrow(eyebrow);
    const sanitizedCategoryLink = sanitizeCategoryLinks([categoryLink]);
    const sanitizedSubLinks = sanitizeCategoryLinks(subLinks);
    const [isSmallScreen, setIsSmallScreen] = useState(window.matchMedia(`(max-width: ${TWO_COLUMN_MAX_WIDTH})`).matches);
    const onClick = useCallback((x) => {
        onNavigate();
        clearActiveSubmenu(x);
    }, [clearActiveSubmenu, onNavigate]);
    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${TWO_COLUMN_MAX_WIDTH})`);
        const handleResize = () => setIsSmallScreen(mediaQuery.matches);
        mediaQuery.addListener(handleResize);
        return () => mediaQuery.removeListener(handleResize);
    }, []);
    return (React.createElement(CategoryLinkListSection, { delay: delay },
        React.createElement(EyebrowLabel, null, sanitizedEyebrow),
        React.createElement("nav", null,
            React.createElement("li", { key: 0 },
                React.createElement(TextLink, Object.assign({ onClick: onClick, size: isSmallScreen ? 'large' : 'medium' }, sanitizedCategoryLink[0], { trackingCategory: trackCat }))),
            sanitizedSubLinks.map((link, index) => (React.createElement("li", { key: index + 1 },
                React.createElement(TextLink, Object.assign({ onClick: onClick, size: isSmallScreen ? 'medium' : 'small' }, link, { trackingCategory: trackCat }))))))));
};
//# sourceMappingURL=index.js.map